import { CELL_STYLES, LEGEND_ORDER, type LegendKey } from './roster-shared';

export default function AvailabilityLegend({
  declaredCount,
  total,
}: {
  declaredCount: number;
  total: number;
}) {
  const sw = (key: LegendKey): React.CSSProperties => ({
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: 2,
    marginRight: 4,
    verticalAlign: '-1px',
    ...CELL_STYLES[key].swatch,
  });
  return (
    <div
      style={{
        display: 'flex',
        gap: 10,
        fontSize: 10,
        color: 'var(--nb-subtle)',
        flexWrap: 'wrap',
      }}
    >
      {LEGEND_ORDER.map((key) => (
        <span key={key}>
          <i style={sw(key)} />
          {CELL_STYLES[key].label}
        </span>
      ))}
      {/* Adoption hint (BON-241): an empty grid means "not filled in yet",
          not "nobody is free". */}
      <span style={{ color: 'var(--nb-faint)' }}>
        {declaredCount} of {total} set
      </span>
    </div>
  );
}
